import { useUser } from 'api'
import styles from './TopBar.module.scss'

export const UserPill = () => {
  const { user } = useUser()

  const email = user?.email
  // @todo - users may have more than one account/org going forward, fix this when 360 is built to cope with that.
  const orgName = user?.accounts?.[0]?.accountorganisation?.name

  return email ? (
    <div className={styles['user-pill']}>
      <h4>{email}</h4>
      <h5>{orgName}</h5>
    </div>
  ) : (
    ''
  )
}
